var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-pair"},[_c('TextButton',{attrs:{"label":"홈으로 이동"},on:{"click":function($event){return _vm.$emit('home-click')}}}),_vm._v(" "),_c('span',{staticClass:"button-pair__divider"}),_vm._v(" "),_c('TextButton',{attrs:{"label":"로그아웃"},on:{"click":function($event){return _vm.$emit('logout-click')}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66fc7302","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/new/molecules/ButtonPair.vue
// module id = null
// module chunks = 